import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Learn about how to engage the IBM Brand Experience and Design and IBM Global Real Estate teams in your projects. Discover where you can find answers to specific questions.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">IBM Brand Experience and Design</AnchorLink>
  <AnchorLink mdxType="AnchorLink">IBM Global Real Estate</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Contacts</AnchorLink>
    </AnchorLinks>
    <h2>{`IBM Brand Experience and Design`}</h2>
    <p>{`Our IBM Brand Experience and Design (BXD) team guides the IBM brand image and design language across all touchpoints, including master brand identity, product, industrial, event and workplace design. The team is comprised of brand strategists, naming experts, graphic designers, industrial designers and architects.`}</p>
    <p>{`Our team provides creative direction for our workplaces globally, working closely with our IBM Global Real Estate colleagues and agency partners to ensure continuity across a variety of workplace formats, locations and sizes. The BXD team should be engaged throughout project development—including onboarding of external contributors at kickoff, as well as continuing consultation throughout the design process. Collaboration among all teams is essential to successfully deliver the highest-quality workplace experience for our clients and our colleagues.`}</p>
    <p>{`We provide:`}</p>
    <ul>
      <li parentName="ul">{`Initial briefings on IBM brand strategy or the workplace design language for architects and creative agencies`}</li>
      <li parentName="ul">{`Brand design, including brand programming and opportunity mapping, creative development and source files for production`}</li>
      <li parentName="ul">{`Direction, review and approval of brand proposals from external agencies`}</li>
      <li parentName="ul">{`Consultation on feature architectural elements, such as Arrival and Welcome zones, custom patterns and millwork, custom furniture, reception desks, custom artwork, high-profile media installations, environmental graphics, exhibit displays, and signage`}</li>
    </ul>
    <h3>{`Collaboration and approvals with our team`}</h3>
    <p>{`The BXD team provides project-specific direction for most major workplace projects. Contact our team early in the planning and design phases of any significant project so you can benefit from collaborating with our design experts.`}</p>
    <p>{`All branding projects conducted with an approved creative agency should be reviewed by our team with adequate time for feedback and adjustments well in advance of stakeholder reviews. When possible, our team should brief the agency at kickoff.`}</p>
    <p>{`To alert our team on new projects and coordinate our participation, send a message to our Slack channel `}<a parentName="p" {...{
        "href": "https://bsxd.slack.com/channels/ibm-brand"
      }}>{`#ibm-brand`}</a>{`, with a brief description of the project scope and timeline. Be aware that the IBM Workplace brand team is small, so contacting us early in your project is the best way to ensure timely project support.`}</p>
    <h2>{`IBM Global Real Estate`}</h2>
    <p>{`The IBM Global Real Estate team manages all IBM properties globally. Part of this responsibility is held by IBM Workplace Solutions and IBM Workplace Experience who build and manage the workplace environments with a team of strategists, architects, project managers, and engineering, construction and operations experts. The IBM Center of Excellence (CoE) for Workplace Experience manages all touchpoints with employees and the workplace.`}</p>
    <p>{`This team provides direction and management for all real estate construction projects, including:`}</p>
    <ul>
      <li parentName="ul">{`Planning and development of the workplace`}</li>
      <li parentName="ul">{`Design and construction management`}</li>
      <li parentName="ul">{`Managing architects and engineering consultants`}</li>
      <li parentName="ul">{`Infrastructure and technology design`}</li>
      <li parentName="ul">{`Sustainability and wellness reviews`}</li>
    </ul>
    <h3>{`Collaboration with the IBM Global Real Estate team`}</h3>
    <p>{`Contact this team to get started on your project `}<a parentName="p" {...{
        "href": "https://w3.ibm.com/w3publisher/greworkplace/meet-the-team"
      }}>{`here`}</a>{`.`}</p>
    <h2>{`Contacts`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard title="#ibm-brand" subTitle="IBM Brand Experience and Design team" href="https://bsxd.slack.com/channels/ibm-brand" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/61f021ea7b6b08f56b14b0b2b7064c8d/slack.svg",
            "alt": "Bee"
          }}></img>
        </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Global Real Estate" href="https://w3.ibm.com/w3publisher/greworkplace/meet-the-team" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/e73f9cb39d46db58cd110bfbcdf3a775/ibm.svg",
            "alt": "IBM"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      